module.exports = __webpack_public_path__ + "static/media/DecorativeLine.c59b8e68.svg";